module.exports = __webpack_public_path__ + "img/carousel-arrow.c3acd1f5.svg";